import { render, staticRenderFns } from "./CloseTicketDialog.vue?vue&type=template&id=30d39d12&"
import script from "./CloseTicketDialog.vue?vue&type=script&lang=js&"
export * from "./CloseTicketDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports